import React from "react";

function Button({ onClick, text, className, disabled, loading, noPadding, icon }) {
  return (
    <button
      onClick={onClick}
      className={`bg-black hover:bg-[#424141] text-white font-bold ${noPadding ? "" : "py-2 px-4"} rounded ${className} ${disabled ? "cursor-not-allowed opacity-50" : ""} ${loading ? "pointer-events-none" : ""}`}
      disabled={disabled || loading}
    >
      {/* {loading ? "Loading..." : text} */}
      {loading ? (
        "Loading..."
      ) : (
        <span className="flex items-center gap-2">
          {icon && <span>{icon}</span>}
          {text}
        </span>
      )}
    </button>
  );
}

export default Button;
